<template>
  <div class="horizontal-view">
    <div class="heading">
      <div class="md-icon">{{ item.getIcon() }}</div>
      <div>{{ item.getText() }}</div>
      <button @click="add" v-if="itemID.startsWith('root:')">{{ addText }}</button>
    </div>
    <HelpHint :itemID="itemID" />
    <div class="content">
      <SortableList
        :parent="item"
        :elements="item.getChildren()"
        compType="list"
        :horizontal="true"
      />
      <AddItem :targetID="itemID" />
    </div>
  </div>
</template>

<style scoped>
.horizontal-view {
  display: flex;
  flex-direction: column;
}

.heading {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}
.heading .md-icon {
  padding: var(--basic-padding);
}
.heading button {
  background: var(--card-color-default);
  padding: 4px 12px;
  margin-left: 12px;
  border-radius: var(--rounding-larger);
}

.content {
  display: flex;
  flex-direction: row;
}
.elements {
  gap: 0;
}
.add-item {
  height: 56px;
  margin: 8px;
  min-width: 240px;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import AddItem from "../components/AddItem.vue";
import SortableList from "../components/SortableList.vue";
import HelpHint from "@/components/HelpHint.vue";

export default {
  props: ["itemID"],
  components: {
    AddItem,
    SortableList,
    HelpHint,
  },
  computed: {
    item() {
      return getItem(this.itemID);
    },
    addText() {
      switch (this.item._id.split(":")[1]) {
        case "list":
          return "Dodaj nową";
        case "period":
          return "Dodaj nowy";
        default:
          return "Dodaj...";
      }
    },
  },
  methods: {
    add() {
      this.item.createChild(this.item._id.split(":")[1], `Nazwa:`);
    },
  },
};
</script>
